<template>
    <vs-select
        ref="selector"
        class="vx-select"
        :class="{
            'active': focused,
            'with-label': labelPlaceholder ? false : label,
            'validation-padding': !removeValidationPadding
        }"
        v-model="value_x"
        v-bind="$attrs"
        v-on="$listeners"
        :label="label_text"
        :label-placeholder="placeholder_text"
        :autocomplete="autocomplete"
        :icon="icon"
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown.tab.shift.prevent="tabBack"
        @keydown.tab.exact.prevent="tabNext"
        @input="itemSelected"
        @click="deepFocus"
        icon-pack="feather"
        val-icon-success="icon-check"
        val-icon-danger="icon-x"
        :name="name"
        v-validate="`${validationRule}`"
        :danger="errors.has(name)"
        :danger-text="errors.first(name)"
    >
        <div :id="listId">
            <vs-select-item
                v-for="(item, index) in options"
                :key="index"
                :value="getValue(item)"
                :text="getText(item)"
                @keydown.tab.shift.prevent="tabBack"
                @keydown.tab.exact.prevent="tabNext"
            />
        </div>
    </vs-select>
</template>

<script>
import validationMixins from '@/plugins/validationMixins.js'

export default {
    name: 'vx-select',
    mixins: [validationMixins],
    props: {
        value: {
            type: null
        },
        icon: {
            type: String,
            default: 'icon-chevron-down'
        },
        label: {
            type: String
        },
        labelPlaceholder: {
            type: String
        },
        autocomplete: {
            type: Boolean
        },
        options: {
            type: Array,
            required: true
        },
        valueKey: {
            type: null
        },
        textKey: {
            type: null
        },
        idKey: {
            type: null
        },
        removeValidationPadding: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focused: false
        }
    },
    computed: {
        value_x: {
            get() {
                if (!this.value) {
                    return null
                }
                if (this.idKey) {
                    return this.options.find((o) => this.value[this.idKey] === o[this.idKey])
                }
                return this.value
            },
            set(val) {
                this.$emit('input', this.getValue(val))
            }
        },
        hasLabel() {
            return this.label || this.labelPlaceholder
        },
        select() {
            return this.$refs.selector || {}
        },
        listId() {
            return `dropdown${this._uid}`
        }
    },
    methods: {
        handleFocus(e) {
            e.target.setAttribute('autocomplete', window.generateGuid())
            this.focused = true
            this.$emit('focus', e)
        },
        handleBlur(e) {
            this.focused = false
            this.$emit('blur', e)
        },
        deepFocus(e) {
            this.select.focus()
        },
        closeMenu() {
            this.select.closeOptions()
        },
        itemSelected(val) {
            if (this.autocomplete) {
                this.deepFocus()
                this.closeMenu()
            } else {
                this.tabNext()
            }
            this.$emit('input', val)
            this.$emit('selected', val)
        },
        getText(item) {
            if (typeof this.textKey === 'function') {
                return this.textKey(item)
            } else if (typeof item === 'object' && this.textKey) {
                return item[this.textKey]
            }
            return item
        },
        getValue(item) {
            if (typeof this.valueKey === 'function') {
                return this.valueKey(item)
            } else if (typeof item === 'object' && this.valueKey) {
                return item[this.valueKey]
            }
            return item
        },
        tabNext(e) {
            this.$nextTick(() => {
                if (this.select) {
                    var next = this.select.$el.nextFormField()
                }
                this.closeMenu()
                if (next) {
                    next.focus()
                }
            })
        },
        tabBack(e) {
            this.$nextTick(() => {
                if (this.select) {
                    var prev = this.select.$el.nextFormField()
                }
                this.closeMenu()
                if (prev) {
                    prev.focus()
                }
            })
        }
    },
    mounted() {
        this.$watch('$refs.selector.active', (new_value, old_value) => {
            this.deepFocused = new_value
        })
    }
}
</script>

<style scoped>
.con-select.active ::v-deep label {
    color: rgba(var(--vs-primary), 1);
}
.con-select.active ::v-deep input {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.con-select.active ::v-deep i {
    color: rgba(var(--vs-primary), 1);
}
.validation-padding ::v-deep .input-select-con + span {
    height: 19px;
    content: '\200b';
    width: 100%;
    display: block;
}
</style>
